import { isUndefined, isNull } from 'lodash'
import moment from 'moment'
import React from 'react'

interface Props {
    record: any
}

const ExpandedRow: React.FC<Props> = (props) => {
    const { record } = props

    const myIsNull = (value: any) => {
        if (isUndefined(value) || isNull(value)) return ''
        return value
    }

    const getValue = () => {
        return record.latest.treeForm.yaw || record.latest.temperature || ''
    }
    
    return (
        <div>
            <div>TREEID: {record.treeId}</div>
            <div>DEUI: {record.platform === 'lora' ? record.deviceId : record.DEUI}</div>
            <div>APPKEY: {record.APP_KEY}</div>
            <div>APPEUI: {record.APP_EUI}</div>
            {record.latest ? (
                <div>
                    <div>Latest Update Time: {moment(record.latest.recordedAt).format('YYYY-MM-DD HH:mm:ss')}</div>
                    <div>Latest Data Package: {record.latest.text}</div>
                    {record.location ? (
                        <div>
                            Lat: {`${myIsNull(record.location.latitude)}, Lng: ${myIsNull(record.location.longitude)}`}
                        </div>
                    ) : null}
                    <div>TDC: {`${myIsNull(record.latest.TDC)} mins, STDC: ${myIsNull(record.latest.STDC)} mins`}</div>
                    <div>RSSI: {record.latest.rssi || record.latest.CSQ}</div>
                    <div>SNR: {`${myIsNull(record.latest.snr)}`}</div>
                    <div>Roll: {`${myIsNull(record.latest.treeForm.roll)}º`}</div>
                    <div>Pitch: {`${myIsNull(record.latest.treeForm.pitch)}º`}</div>
                    <div>
                        {record.title.indexOf('P3') > -1 ? 'Temperature' : 'Yaw/Temperature:'} {`${getValue()}`}
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default ExpandedRow
